module.exports = __webpack_public_path__ + "static/fonts/Fact-Regular.ff980e4.eot";